import React from "react";
import SectionHeader from "./SectionHeader";


function LCorManual({
  expandedSections,
  onChange = () => {},
  toggleSection,
  formData,
  labelClass,
  inputClass,

}) {


  return (
    <div className=" rounded border border-slate-200 dark:border-slate-700 overflow-hidden">
      
    
        <>
          <div className="flex items-center gap-3  p-4  border-b border-slate-200 dark:border-slate-700">
            <button className="px-3 py-1.5 bg-red-600 hover:bg-red-700 text-white text-sm rounded font-medium">
              Fetch Cargo Description
            </button>

            <div className="flex-1" />
            <div className="flex items-center gap-2"></div>
          </div>
   <div className="p-4">
  <div className="grid grid-cols-1 md:grid-cols-[2fr_3fr] gap-4">

    {/* LEFT SIDE */}
    <div className="grid grid-cols-1 md:grid-cols-[3fr_2fr] gap-4">

      {/* Container / Marks No */}
      <div className="flex flex-col">
        <label className={labelClass}>Container / Marks No:</label>
        <textarea 
          rows={6}
          className={`${inputClass} mt-2 font-mono text-xs resize-none`}
          value={formData?.dockReceiptCargoDescription?.[0]?.markssealno}
          onChange={(e) =>
            onChange("markssealno", e.target.value, "text")
          }
        />
      </div>

      {/* No. of Package */}
      <div className="flex flex-col">
        <label className={labelClass}>No. of Package:</label>
        <textarea
          rows={6}
          className={`${inputClass} mt-2 font-mono text-xs resize-none`}
          value={formData?.dockReceiptCargoDescription?.[0]?.noofpacages}
          onChange={(e) =>
            onChange("noofpacages", e.target.value, "text")
          }
        />
      </div>

    </div>

    {/* RIGHT SIDE */}
    <div className="grid grid-cols-1 md:grid-cols-[4fr_3fr_3fr] gap-4">

      {/* Cargo Description */}
      <div className="flex flex-col">
        <label className={labelClass}>Cargo Description:</label>
        <textarea
          rows={6}
          className={`${inputClass} mt-2 font-mono text-xs resize-none`}
          value={formData?.dockReceiptCargoDescription?.[0]?.commoditydescription}
          onChange={(e) =>
            onChange("commoditydescription", e.target.value, "text")
          }
        />
      </div>

      {/* Gross Weight */}
      <div className="flex flex-col">
        <label className={labelClass}>Gross Weight:</label>
        <textarea
          rows={6}
          className={`${inputClass} mt-2 font-mono text-xs resize-none`}
          value={formData?.dockReceiptCargoDescription?.[0]?.grossweight}
          onChange={(e) =>
            onChange("grossweight", e.target.value, "text")
          }
        />
      </div>

      {/* Measurement */}
      <div className="flex flex-col">
        <label className={labelClass}>Measurement:</label>
        <textarea
          rows={6}
          className={`${inputClass} mt-2 font-mono text-xs resize-none`}
          value={formData?.dockReceiptCargoDescription?.[0]?.grossmeasurment}
          onChange={(e) =>
            onChange("grossmeasurment", e.target.value, "text")
          }
        />
      </div>

    </div>

  </div>
</div>


        </>
 
    </div>
  );
}

export default LCorManual;